import cartFunctions from "./cart-functions";
import block from './block';

function addToCartProduct(){
    $('body').on('click', '[data-ajax-add-to-cart-product]', function (){
        let singleProductPage = null;
        let quantity = null;
        if($('body').hasClass('single-product')) {
            singleProductPage= document.querySelector('.single-product');
            quantity = singleProductPage.querySelector('form.cart [data-quantity-input]');
        }

        if (singleProductPage && quantity) {
            cartFunctions.changeCartQuantity($(this)[0], quantity.value);
        } else {
            cartFunctions.changeCartQuantity($(this)[0], 1);
        }
    });
}

export default {addToCartProduct};


// WEBPACK FOOTER //
// ./src/scripts/add-to-cart.js